import StatusHandler from 'app/shared-components/StatusHandler'
import request from 'app/requests/FreightForwarder.request'
import useGetFreightForwarder from 'app/Apps/OrderManagement/hooks/useGetFreightForwarder'

import FreightForwarderForm from '../FreightForwarderForm'

type Props = {
    id: number,
    disabled?: boolean
}

const defaultProps = {
    disabled: false,
}

const FreightForwarderUpdate = ({
    id,
    disabled,
}: Readonly<Props>) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetFreightForwarder(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FreightForwarderForm
                onSuccess={invalidate}
                onCancel={invalidate}
                data={data}
                disabled={disabled}
                request={request.update({
                    id,
                })}
            />
        </StatusHandler>
    )
}

FreightForwarderUpdate.defaultProps = defaultProps

export default FreightForwarderUpdate
